import { keys } from './keys';

export const environment = {
  app: 'Designly',
  htmlEndpoint: 'https://stage-app.designly.uk',
  apiEndpoint: 'https://stage-api.designly.uk',
  s3BucketUrl: 'https://s3.eu-west-2.amazonaws.com/stage-resources.designly.uk/resources/',
  particaEndpoint: 'https://api.dev.partica.online',
  particaViewerEndpoint: 'https://viewerdev.cdn.partica.online/viewer',
  particaArticleEndpoint: 'https://articles.dev.partica.online',
  vaultClientId: keys.VAULT_CLIENT_ID,
  particaPartnerId: keys.PARTICA_PARTNER_ID,
  slackWebHook: keys.SLACK_WEBHOOK,
  domainClientId: keys.DOMAIN_CLIENT_ID,
  vaultUkClientId: keys.VAULT_UK_CLIENT_ID,
  isUk: true,
  production: false
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts